function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color } from 'styled-system';
import styledPropTypes from '@styled-system/prop-types';
import { strictSpace } from '../../utils';
/**
 * Renders a list.
 */

var List = styled.ul.withConfig({
  displayName: "List",
  componentId: "sc-lf0zti-0"
})(["list-style:none;list-style-type:", ";", " ", ""], function (_ref) {
  var variant = _ref.variant;
  return variant || 'disc';
}, strictSpace, color);
List.propTypes = _objectSpread({
  variant: PropTypes.string,
  color: PropTypes.string
}, styledPropTypes.space);
List.defaultProps = {
  pl: '1em'
};
export var OrderedList = styled(List).attrs({
  as: 'ol'
}).withConfig({
  displayName: "List__OrderedList",
  componentId: "sc-lf0zti-1"
})(["list-style-type:decimal;"]);
/** @component */

export default List;